import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sliderName: "",
  changeMade: false,
};

export const paymentSchedulePanelSlice = createSlice({
  name: 'paymentSchedulePanel',
  initialState,
  reducers: {
    setSliderName: (state, action) => {
      state.sliderName = action.payload;
    },
    setChangeMade: (state, action) => {
      state.changeMade = action.payload;
    },
  },
});

export const { setSliderName, setChangeMade } = paymentSchedulePanelSlice.actions;
export const selectPaymentSchedulePanel = (state) => state.paymentSchedulePanel;

export default paymentSchedulePanelSlice.reducer;
